/*
  Communite homepage reveal controller
  Content remains visible without JavaScript and in reduced-motion mode.
*/

(() => {
  const ROOT_SELECTOR = '[data-cm-home-reveal]'
  const controllers = new WeakMap()
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

  const findRoots = (root) => {
    const roots = []

    if (root instanceof Element && root.matches(ROOT_SELECTOR)) {
      roots.push(root)
    }

    root.querySelectorAll?.(ROOT_SELECTOR).forEach(element => roots.push(element))
    return roots
  }

  class CommuniteHomeReveal {
    constructor (root) {
      this.root = root

      if (reduceMotion.matches || !('IntersectionObserver' in window)) {
        root.classList.add('is-visible')
        return
      }

      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return
          entry.target.classList.add('is-visible')
          this.observer.unobserve(entry.target)
        })
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })

      this.observer.observe(root)
    }

    show () {
      this.root.classList.add('is-visible')
      this.observer?.unobserve(this.root)
    }

    destroy () {
      this.observer?.disconnect()
      controllers.delete(this.root)
    }
  }

  const init = (root = document) => {
    document.documentElement.classList.add('cm-home-reveal-enabled')

    findRoots(root).forEach(element => {
      if (controllers.has(element)) return
      controllers.set(element, new CommuniteHomeReveal(element))
    })
  }

  const destroy = (root) => {
    findRoots(root).forEach(element => controllers.get(element)?.destroy())
  }

  document.addEventListener('shopify:section:load', event => init(event.target))
  document.addEventListener('shopify:section:unload', event => destroy(event.target))
  document.addEventListener('shopify:section:select', event => {
    init(event.target)
    findRoots(event.target).forEach(element => controllers.get(element)?.show())
  })

  init(document)
})()
